<template>
    <app-table-view :header="header" :items="model.citizenships">
        <template slot="default" slot-scope="{ item }">
            <v-layout row wrap>
                <v-flex>
                    <span>{{item.country_name}}</span>
                </v-flex>
            </v-layout>
        </template>
    </app-table-view>
</template>

<script>
    import AppTableView from "../../common/table-view";
    export default {
        name: "app-resume-citizenships-view",
        components: {AppTableView},
        data() {
            return { header: "Гражданство" };
        },
        props : {
            model : {}
        }
    }
</script>
